import { Grid, WithStyles } from "@material-ui/core";
import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import React from "react";
import { styles } from "./SampleFile.styles";
import { withStyles } from "@material-ui/core/styles";
import { AnchorLink } from "../../components/Links/AnchorLink";
import { BlueLink } from "../../components/Links/BlueLink";

export interface ISampleFilesProps extends WithStyles<typeof styles> {
    files: any;
    useCaseCategoryId?: number;
}

const SampleFilesPure: React.FunctionComponent<ISampleFilesProps> = ({
    files,
    useCaseCategoryId,
    classes
}: ISampleFilesProps) => {
    return (
        <Grid container spacing={2} className={classes.root}>
            {files.map(file => (
                <Grid key={file.name} item xs={5}>
                    <SystemUpdateAltIcon />
                    <AnchorLink className={classes.sampleLink} variant="subtitle2" to={file.path}>
                        {file.name}
                    </AnchorLink>
                </Grid>
            ))}
            {useCaseCategoryId !== null ? (
                <Grid key={useCaseCategoryId} item xs={5}>
                    <TrendingUpIcon />
                    <BlueLink className={classes.sampleLink} variant="subtitle2" to={`/use-cases/${useCaseCategoryId}`}>
                        Use cases
                    </BlueLink>
                </Grid>
            ) : null}
        </Grid>
    );
};

export const SampleFiles = withStyles(styles)(SampleFilesPure);
